import { useQuery } from "@tanstack/react-query"

import type { PromptLibraryResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getPrompts(): Promise<PromptLibraryResponse> {
  return api.get("/explorer/prompts")
}

export function useGetPrompts() {
  const promptsQuery = useQuery({
    queryKey: queryKeys.prompts,
    queryFn: () => getPrompts(),
    enabled: true,
  })

  return promptsQuery
}
